import './style.scss'
import { Button, message, Modal } from 'antd'
import { FC, memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as homeApi from '@/api/home'
import { IProduct } from '@/global-states'
import { BankOutlined, UserOutlined } from '@ant-design/icons'
import UserModalHeader from '../UserModalHeader'

interface IProps {
  product?: IProduct
  open: boolean
  onCancel?: () => void
  onSuccess?: () => void
}

const ContractModal: FC<IProps> = (props) => {
  const { t: translate } = useTranslation(['contract_modal'])
  const { open, onCancel, onSuccess } = props
  const [role, setRole] = useState(0)
  const [loading, setLoading] = useState(false)

  const signContract = async () => {
    try {
      setLoading(true)
      const res = await homeApi.addNewContract({
        is_corp: role === 0 ? false : true
      })
      if (res?.signing_url) {
        window.open(res.signing_url)
      }
    } finally {
      setLoading(false)
    }
  }

  const checkContract = async () => {
    homeApi.getContractList()
    const res = await homeApi.checkContract()
    if (!res?.require_new_contract) {
      onCancel?.()
      onSuccess?.()
    } else {
      message.warning(translate('contract_modal.no_active_contract_warning'))
    }
  }

  return (
    <>
      <Modal className="contract-modal" footer={null} width={780} onCancel={() => onCancel?.()} open={open}>
        <div className="pay-content">
          <UserModalHeader />
          <div className="contract-content">
            <div className="title">{translate('contract_modal.contract_prompt')}</div>
            <div className="role">
              <div className={`role-item ${role === 0 ? 'actived' : ''}`} onClick={() => setRole(0)}>
                <UserOutlined />
                <div>{translate('contract_modal.individual')}</div>
              </div>
              <div className={`role-item ${role === 1 ? 'actived' : ''}`} onClick={() => setRole(1)}>
                <BankOutlined />
                <div>{translate('contract_modal.enterprise')}</div>
              </div>
            </div>

            <div className="friedly-tips">
              <div className="tips-title">{translate('contract_modal.friendly_reminder')}</div>
              <div>{translate('contract_modal.tip_1')}</div>
              <div>{translate('contract_modal.tip_2')}</div>
              <div>{translate('contract_modal.tip_3')}</div>
            </div>

            <div className="bottom">
              <div className="tip">{translate('contract_modal.rights_protection_tip')}</div>

              <Button type="primary" loading={loading} onClick={signContract}>
                {translate('contract_modal.sign_contract_button')}
              </Button>
              <Button type="default" onClick={checkContract}>
                {translate('contract_modal.completed_signing_button')}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default memo(ContractModal)
